<div class="pt-2">
    <div class="container-md">
        <router-outlet></router-outlet>
    </div>
</div>
